/** Shared grid templates so header and row cells stay column-aligned. */
export const INPUT_PARAMETER_TABLE_GRID =
  'grid-cols-[minmax(180px,1fr)_minmax(180px,1fr)_140px_140px_180px_100px_100px]';
export const INPUT_PARAMETER_TABLE_COL_SPAN = 'col-span-7';

export const OUTPUT_PARAMETER_TABLE_GRID =
  'grid-cols-[minmax(200px,2fr)_minmax(200px,2fr)_140px_100px_100px]';
export const OUTPUT_PARAMETER_TABLE_COL_SPAN = 'col-span-5';
